namespace Matrix.DataAudit {
    export interface AccountHistoryForm {
        AccountCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        AccountTypeCode: FormatLookupEditor;
        AccountTypeName: Serenity.StringEditor;
        AccountRoleCode: FormatLookupEditor;
        AccountRoleName: Serenity.StringEditor;
        ManagerCode: FormatLookupEditor;
        ManagerName: Serenity.StringEditor;
        BaseCurrencyCode: Serenity.LookupEditor;
        AssetClass: Serenity.StringEditor;
        Benchmark1: FormatServiceLookupEditor;
        Benchmark2: FormatServiceLookupEditor;
        InceptionDate: Serenity.DateEditor;
        TerminationDate: Serenity.DateEditor;
        InvestmentObjective: Serenity.StringEditor;
        PerformanceBenchmark1: FormatServiceLookupEditor;
        PerformanceBenchmark2: FormatServiceLookupEditor;
        PerformanceInceptionDate: Serenity.DateEditor;
        PerformanceTerminationDate: Serenity.DateEditor;
        Generation: Serenity.IntegerEditor;
        IsCurrent: Serenity.StringEditor;
        CurrentFrom: Serenity.StringEditor;
        CurrentTo: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        SourceCreatedBy: StaticTextBlock;
        SourceCreatedWhen: ReadOnlyDateTime;
        SourceUpdatedBy: StaticTextBlock;
        SourceUpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountHistoryForm extends Serenity.PrefixedContext {
        static formKey = 'DataAudit.AccountHistory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountHistoryForm.init)  {
                AccountHistoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.LookupEditor;
                var w3 = FormatServiceLookupEditor;
                var w4 = s.DateEditor;
                var w5 = s.IntegerEditor;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(AccountHistoryForm, [
                    'AccountCode', w0,
                    'Name', w0,
                    'AccountTypeCode', w1,
                    'AccountTypeName', w0,
                    'AccountRoleCode', w1,
                    'AccountRoleName', w0,
                    'ManagerCode', w1,
                    'ManagerName', w0,
                    'BaseCurrencyCode', w2,
                    'AssetClass', w0,
                    'Benchmark1', w3,
                    'Benchmark2', w3,
                    'InceptionDate', w4,
                    'TerminationDate', w4,
                    'InvestmentObjective', w0,
                    'PerformanceBenchmark1', w3,
                    'PerformanceBenchmark2', w3,
                    'PerformanceInceptionDate', w4,
                    'PerformanceTerminationDate', w4,
                    'Generation', w5,
                    'IsCurrent', w0,
                    'CurrentFrom', w0,
                    'CurrentTo', w0,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'SourceCreatedBy', w6,
                    'SourceCreatedWhen', w7,
                    'SourceUpdatedBy', w6,
                    'SourceUpdatedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
